<template>
    <section id="location" class="Location white">
        <div class="row">
            <div class="col s12 m12 l12 xl7 left-text description">
                <!-- <div class="title centfer">Location</div> -->
                <div class="title show-on-medium-and-down"><img src="/assets/images/location.png"></div>
                <div class="title hide-on-large-and-down"><img src="/assets/images/location2.png"></div>
                <table>
                    <tr>
                        <td>
                            <i class="ln ln-icon-Location-2"></i>
                        </td>
                        <td>
                            835 Grove Street<br>
                            Clifton, NJ 07013<br>
                            <a href="https://www.waze.com/ul?ll=40.85605218%2C-74.19220805&navigate=yes&zoom=17" target="_blank">Get Directions</a><br><br>
                            <em><small>* Free parking on premise</small></em>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <i class="ln ln-icon-Phone-2"></i>
                        </td>
                        <td v-html='showPhone("862","238","7560")'>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <i class="ln ln-icon-Envelope"></i>
                        </td>
                        <td v-html='showEmail("houseoffirechristianchurch","gmail","com")'>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <i class="ln ln-icon-Video-5"></i>
                        </td>
                        <td>
                            <a :href="facebookLive" target="_blank">{{facebookLiveText}}</a>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col s12 m12 l12 xl5 image">
                <!-- <img src="/assets/images/map.png"> -->
            </div>
        </div>
    </section>
</template>

<script>
    import ENV from '../constants/Environment.js';

    export default {
        name: 'Location',
        data: function() {
            return {   
                facebookLive: ENV.FACEBOOK_LIVE_LINK, 
                facebookLiveText: ENV.FACEBOOK_LIVE_LINK_TEXT
            }
        },
        methods: {
            showEmail: function (nm,domain,dotcom) {
                return "<a href='mailto:" + nm + "@" + domain + "." + dotcom + "'>" + nm + "@" + domain + "." + dotcom + "</a>";
            },
            showPhone: function (area,first,second) {
                return "<a href='tel:" + area + "" + first + "" + second + "'>" + area + "." + first + "." + second + "</a>";
            }
        }
    }
</script>

<style scoped>
    .title {
        font-weight: normal;
        font-size: 2.5rem;
        margin-bottom: 1rem;
        letter-spacing: .06rem;
    }

    .image {
        padding-right: 0;
    }

    .Location .image {
        background: url(/assets/images/map.png);
        height: 600px;
        background-size: cover;
        background-position: center;
        filter: grayscale(100%);
    }

    tr {
        border: none;
    }

    td { 
        vertical-align: top;
        font-size: 1.25rem;
        word-break: break-all;
        word-wrap: break-word;
    }
    i.ln {
        font-size: 2rem;
        position: relative;
        top: -5px;
    }

    .description {
        padding: 4rem 3rem 4rem 4rem;
        font-size: 1.5rem;
        line-height: 1.25;
    }

    @media only screen and (min-width: 993px) {
        .show-on-medium-and-down {
            display: none;
        }
    }

    @media only screen and (max-width: 992px) {
        .hide-on-large-and-down {
            display: none;
        }

        .title {
            text-align: center;
        }

        .description {
            padding: 4rem 2rem 4rem 2rem;
        }

        .Location .image {
            max-height: 300px
        }
    }
</style>